import {
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import styled from 'styled-components';

export const Item = styled(AccordionItem)`
  margin-bottom: 10px;
`;

export const ItemHeader = styled(AccordionItemHeading)`
  cursor: pointer;

  //TO DO: CORRIGIR PARA PEGAR COR DA THEME (LIGHT E DARK)
  background: #2060a5;
  color: #fff;
  border-radius: 5px;
`;

export const ItemPanel = styled(AccordionItemPanel)`
  //TO DO: CORRIGIR PARA PEGAR COR DA THEME (LIGHT E DARK)
  background: #27293d;
  padding: 5px;
  overflow: hidden;
  transition: max-height 2s ease-out;
  -webkit-transition: max-height 2s ease-out;
`;
export const ItemButton = styled(AccordionItemButton)`
  display: flex;
  padding: 5px;
  svg {
    margin-right: 10px;
  }
`;
/* justify-content: space-between; */
